<template>
    <div class="post__click o-grid--center u-width-8/12 u-width-10/12@l u-width-full@m">
        <div v-if="post.network_id !== $simpleStore.Networks.DY && (post.thumbnail || (post.uri && post.network_id === $simpleStore.Networks.IN))"
            class="o-grid__item u-width-full u-align-center"
        >
            <div
                v-if="post.network_id === $simpleStore.Networks.YT"
                class="c-video-wrapper"
                data-id="1"
            >
                <!--<div :id="'player-' + post.video_id" class="post-player" :data-vid="post.video_id"></div>-->
                <youtube
                    :video-id="post.youtube_ref"
                    ref="youtube"
                    :player-vars="youtubeConfig"
                    width="1024"
                    height="576"
                    :resize="true"
                    @playing="playing"
                ></youtube>
            </div>
            <div v-else-if="
                    post.network_id === $simpleStore.Networks.FB &&
                    post.type != null &&
                    post.type.indexOf('video') !== -1"
                 class="video-iframe"
                 :style="aspectRatio"
                 v-html="post.source"
                 data-id="2"
            ></div>
            <div
                v-else-if="
                    post.network_id === $simpleStore.Networks.FB &&
                    post.type === 'album' &&
                    typeof post.media_attachments === 'object'
                "
                ref="fbSlides"
                class="fb-slides"
            >
                <VueSlickCarousel
                    :adaptiveHeight="false"
                    :arrows="true"
                    :autoplay="false"
                    :autoplaySpeed="2500"
                    :draggable="false"
                    :infinite="false"
                    data-id="3"
                >
                    <img
                        v-for="(slide, index) in post.media_attachments"
                        :src="slide.src"
                        alt="slide image"
                        @error="(event) => updateSlide(event, post)"
                        :id="'slide-' + index"
                    >
                </VueSlickCarousel>
            </div>
            <div
                v-else-if="
                    post.network_id === $simpleStore.Networks.IN &&
                    post.type === 'carousel_album' &&
                    post.media_attachments &&
                    typeof post.media_attachments === 'object'
                "
                ref="inSlides"
                class="in-slides"
            >
                <VueSlickCarousel
                    :adaptiveHeight="true"
                    :arrows="true"
                    :autoplay="false"
                    :autoplaySpeed="2500"
                    :draggable="false"
                    :infinite="false"
                    data-id="4"
                >
                    <div v-for="(slide, index) in post.media_attachments" :key="index" class="slick-slide-wrapper">
                        <img
                            v-if="slide.type === 'IMAGE' || !slide.type"
                            :src="slide.src"
                            alt="slide image"
                            @error="(event) => updateSlide(event, post)"
                            :id="'slide-' + index"
                            style="width: 100%; display: block;"
                        >
                        <video
                            v-else-if="slide.type === 'VIDEO'"
                            :src="slide.src"
                            controls
                            style="width: 100%; display: block;"
                            :id="'slide-' + index"
                        ></video>
                        <div v-if="slide.type === 'VIDEO'" class="video-overlay">
                            <img
                                :src="$cdn('/img2.0/icons/play.svg')"
                                class="play-icon"
                                alt="video"
                                width="34"
                                height="39"
                            >
                        </div>
                    </div>

                </VueSlickCarousel>
            </div>
            <video
                v-else-if="
                    post.network_id === $simpleStore.Networks.TW &&
                    typeof post.videoData != 'undefined'
                "
                :width="post.media_width ? post.media_width : '100%'"
                :poster="post.videoData.thumbnailUrl"
                controls
                data-id="5"
            >
                <source :src="post.videoData.videoUrl" type="video/mp4" />
            </video>
            <img
                v-else-if="
                    post.network_id === $simpleStore.Networks.IN &&
                    post.type !== 'video'
                "
                :src="post.uri"
                :alt="post.community_name + ' article image'"
                data-id="6"
                class="instagram-image"
            >

            <div class="instagram-wrapper" v-else-if="
                post.network_id === $simpleStore.Networks.IN &&
                post.type === 'video' &&
                post.uri == null">
                <div v-html="instagramEmbed"></div>
            </div>

            <div class="instagram-video-wrapper" v-else-if="
                post.network_id === $simpleStore.Networks.IN &&
                post.type === 'video'
            ">
                <video
                    v-show="showINVideo"
                    @canplaythrough="showINVideo = true"
                    :width="post.media_width ? post.media_width : '100%'"
                    controls
                    data-id="7"
                    ref="videoInstagram"
                >
                    <source :src="post.uri" type="video/mp4" @error="(event) => updatePost(event, post)" />
                </video>
            </div>
            <img
                v-else
                :src="$simpleStore.transformImageWithCloudfront(812, null, post.thumbnail, $root)"
                :srcset="$simpleStore.transformImageWithCloudfront(812, null, post.thumbnail, $root, 'srcset')"
                :alt="post.community_name + ' article image'"
                width="812"
                data-id="8"
            >
        </div>
        <div v-else-if="post.network_id === $simpleStore.Networks.DY && (post.thumbnail || post.youtube_id || post.media)"
            class="o-grid__item u-width-full u-align-center"
            style="min-height: 250px"
        >
            <template v-if="post.thumbnail">
                <figure class="image" id="thumbnail">
                    <img
                        :src="$simpleStore.transformImageWithCloudfront(812, null, post.thumbnail, $root)"
                        :srcset="$simpleStore.transformImageWithCloudfront(812, null, post.thumbnail, $root, 'srcset')"
                        :alt="post.community_name + ' article image'"
                        :class="post.hero_size"
                        width="812"
                        data-id="9"
                    >
                </figure>
            </template>
            <template v-else-if="post.youtube_id">
                <div class="c-video-wrapper">
                    <youtube
                        :video-id="post.youtube_id"
                        ref="youtube"
                        :player-vars="youtubeConfig"
                        width="1024"
                        height="576"
                        resize="true"
                        @playing="playing"
                        data-id="10"
                    ></youtube>
                </div>
            </template>
            <div v-else-if="post.media" v-html="post.media"></div>
        </div>
        <div class="o-grid__item u-width-full">
            <div class="post__bottom">
                <div ref="postContent" :class="['post__content', post.user_id != null ? 'post__content__ugc' : '']" v-twitteremoji>
                    <div v-html="$simpleStore.highlightHashtags(post.content,post.community_url)"></div>
                    <div class="tweet" v-if="typeof post.embeddedTweet != 'undefined'">
                        <div class="content">
                            <div class="profile">
                                <img :src="post.embeddedTweet.profile_image" alt="profile image">
                                <a :href="post.embeddedTweet.link" target="_blank">@{{ post.embeddedTweet.user }}</a>
                                &#183;
                                {{ post.embeddedTweet.date }}
                            </div>
                            <p v-html="post.embeddedTweet.text"></p>
                        </div>
                        <a :href="post.embeddedTweet.link" target="_blank" v-if="post.embeddedTweet.media != null">
                            <img :src="post.embeddedTweet.media.url" alt="" class="media">
                        </a>
                    </div>
                </div>
                <like-repost-comment
                    :show-reposts="showReposts"
                ></like-repost-comment>
            </div>
            <div :class="['c-comments', 'u-hidden@s', this.showComments ? 'show' : '']">
                <template v-if="post.enable_comments">
                    <p class="comments__title">
                        <template v-if="commentCount !== 1">
                            <span>{{ commentCount }} comments</span>
                            <div class="comments__close u-hidden u-block@s" @click="toggleComments">
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                    <path d="M1 1L13 13" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
                                    <path d="M13 1L1 13" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
                                </svg>
                            </div>
                        </template>
                        <template v-else> {{ commentCount }} comment </template>
                    </p>
                    <post-comments-block></post-comments-block>
                </template>
                <p v-else class="clear u-p-b3">
                    Comments are disabled for this post.
                </p>
                <!-- <reposted-to></reposted-to>
                    <related-communities></related-communities> -->
            </div>
            <div
                class="comments__mobile u-hidden u-block@s"
                @click="toggleComments"
            >
                <div v-if="commentCount !== 1">
                    View {{ commentCount }} comments
                </div>
                <div v-else>View {{ commentCount }} comment</div>
            </div>
        </div>
    </div>
</template>

<style>
.post__title {
    margin-bottom: 0 !important;
}

/* Use padding instead of margin on the slider container.
   Padding never collapses, which prevents the 2rem jump. */
.post__click.o-grid--center {
    padding-top: 2rem;
}
.video-overlay {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    pointer-events: none; /* Crucial: allows clicks to pass through to the video below */
    opacity: 0.8;
    background: rgba(0, 0, 0, 0.2);
    border-radius: 50%;
    padding: 15px;
    transition: opacity 0.3s;
}

/* Hide overlay when video starts playing or is hovered (if supported) */
.slick-slide-wrapper:active .video-overlay {
    opacity: 0;
}
.slick-prev:before,
.slick-next:before {
    color: white;
    position: absolute;
    top: 50%;
}
.slick-prev:before {
    left: 15px;
}
.slick-next:before {
    right: 15px;
}
.slick-prev {
    left: 0;
    height: 100%;
    width: 50px;
    z-index: 1;
}
.slick-next {
    right: 0;
    height: 100%;
    width: 50px;
    z-index: 1;
}

.slick-slide-wrapper {
    display: block !important;
    width: 100%;
    max-height: calc(100vh - 72px); /* Fallback: 100px is an estimate of header height */
    display: flex !important;
    align-items: center;
    justify-content: center;
    background: #000; /* Dark background if media is contained */
    position: relative;
}
.slick-slide-wrapper img,
.slick-slide-wrapper video {
    display: block;
    width: auto !important;
    height: auto !important;
    max-width: 100%;
    max-height: calc(100vh - 72px); /* Matches wrapper constraint */
    margin: 0 auto;
}
</style>

<script>
import Vue from "vue";
import VueYoutube from "vue-youtube";
import LikeRepostComment from "./LikeRepostComment";
import RepostedTo from "./RepostedTo";
import RelatedCommunities from "./RelatedCommunities";
import PostCommentsBlock from "./PostCommentsBlock";
import VueSlickCarousel from "vue-slick-carousel";
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';
import TwitterEmoji from "@twemoji/api";

Vue.use(VueYoutube);

export default {
    components: {
        PostCommentsBlock,
        LikeRepostComment,
        RepostedTo,
        RelatedCommunities,
        VueSlickCarousel,
    },
    data() {
        return {
            admin: false,
            commentCount: this.$root.commentsTotal,
            embeddedTweet: this.$root.embeddedTweet,
            post: { network_id: null },
            updatingSlides: false,
            updatedSlides: [],
            youtubeConfig: {
                autohide: 1,
                controls: 1,
                hl: 'en',
                iv_load_policy: 3,
                modestbranding: 1,
                rel: 0,
                showinfo: 0,
            },
            showINVideo: false,
            showReposts: this.$root.features.guestonly === false && !(this.$root.post?.repost_id > 0),
            showComments: false,
            instagramEmbed: null,
            aspectRatio: null,
            maxMediaHeight: null
        };
    },
    created() {
        this.$root.$on('update-comment-count', (data) => {
            this.commentCount = this.$root.commentsCount;
        });
        this.$root.$on('bus-load-post', (dyadeyId, postId, networkId) => {
            this.loadPost(dyadeyId, postId, networkId);
        });
        this.showPost(this.$root.post);
    },
    mounted() {
        this.loadInstagramScript();
        window.addEventListener('resize', this.monitorResize);
        // calculate max height of viewport
        let maxMediaHeight = window.innerHeight - document.querySelector('header.page__head').offsetHeight;
        let videoIframeWrapper = document.querySelector('.video-iframe');
        let instagramSlidesWrapper = document.querySelector('.in-slides');
        let facebookSlidesWrapper = document.querySelector('.fb-slides');
        let instagramVideoWrapper = document.querySelector('.instagram-video-wrapper');
        let instagramImage = document.querySelector('.instagram-image');
        if (videoIframeWrapper != null) {
            let videoIframeWrapperWidth = videoIframeWrapper.offsetWidth;
            let iframeWidth = videoIframeWrapper.querySelector('iframe').getAttribute('width');
            let iframeHeight = videoIframeWrapper.querySelector('iframe').getAttribute('height');
            let iframeAspectRatio = iframeWidth / iframeHeight;
            let wrapperToIframeRatio = videoIframeWrapperWidth / iframeWidth;
            let iframeActualHeight = iframeHeight * wrapperToIframeRatio;
            let maxMediaHeightToIframeRatio = maxMediaHeight / iframeActualHeight;
            let allowedMediaWidth = maxMediaHeightToIframeRatio * videoIframeWrapperWidth;
            this.aspectRatio = 'aspect-ratio:' + iframeAspectRatio + '; margin: 0 auto';
            videoIframeWrapper.style.maxWidth = videoIframeWrapperWidth + 'px';
            videoIframeWrapper.style.width = allowedMediaWidth + 'px';
        } else if (instagramSlidesWrapper != null) {
            /*const firstSlide = new Image();
            firstSlide.src = document.getElementById('slide-0').src;
            firstSlide.onload = function() {
                let wrapperToSlideRatio = instagramSlidesWrapper.offsetWidth / this.width;
                let slideActualHeight = this.height * wrapperToSlideRatio;
                let maxMediaHeightToSlideRatio = maxMediaHeight / slideActualHeight;
                let allowedMediaWidth = maxMediaHeightToSlideRatio * instagramSlidesWrapper.offsetWidth;
                instagramSlidesWrapper.style.maxWidth = instagramSlidesWrapper.offsetWidth + 'px';
                instagramSlidesWrapper.style.width = allowedMediaWidth + 'px';
                instagramSlidesWrapper.style.margin = '0 auto';
            }*/
        } else if (facebookSlidesWrapper != null) {
            const firstSlide = new Image();
            firstSlide.src = document.getElementById('slide-0').src;
            firstSlide.onload = function() {
                let wrapperToSlideRatio = facebookSlidesWrapper.offsetWidth / this.width;
                let slideActualHeight = this.height * wrapperToSlideRatio;
                let maxMediaHeightToSlideRatio = maxMediaHeight / slideActualHeight;
                let allowedMediaWidth = maxMediaHeightToSlideRatio * facebookSlidesWrapper.offsetWidth;
                facebookSlidesWrapper.style.maxWidth = facebookSlidesWrapper.offsetWidth + 'px';
                facebookSlidesWrapper.style.width = allowedMediaWidth + 'px';
                facebookSlidesWrapper.style.margin = '0 auto';
            }
        } else if (instagramVideoWrapper != null) {
            let video = document.querySelector('.instagram-video-wrapper video');
            video.addEventListener('loadedmetadata', () => {
                let wrapperToVideoRatio = instagramVideoWrapper.offsetWidth / video.videoWidth;
                let videoActualHeight = video.videoHeight * wrapperToVideoRatio;
                let maxMediaHeightToVideoRatio = maxMediaHeight / videoActualHeight;
                let allowedMediaWidth = maxMediaHeightToVideoRatio * instagramVideoWrapper.offsetWidth;
                instagramVideoWrapper.style.maxWidth = instagramVideoWrapper.offsetWidth + 'px';
                instagramVideoWrapper.style.width = allowedMediaWidth + 'px';
                instagramVideoWrapper.style.margin = '0 auto';
            });
        } else if (instagramImage != null) {
            let img = new Image();
            img.src = instagramImage.src;
            img.onload = function() {
                let wrapperToImgRatio = instagramImage.width / this.width;
                let imgActualHeight = this.height * wrapperToImgRatio;
                let maxMediaHeightToSlideRatio = maxMediaHeight / imgActualHeight;
                let allowedMediaWidth = maxMediaHeightToSlideRatio * instagramImage.width;
                instagramImage.style.maxWidth = instagramImage.width + 'px';
                instagramImage.style.width = allowedMediaWidth + 'px';
                instagramImage.style.margin = '0 auto';
            }
        }
        // full width image
        /*if (this.post.network_id === this.$simpleStore.Networks.DY && this.post.thumbnail) {
            // remove images from the content so it is not displayed twice for UGC
            let figure = document.querySelector('#content figure.image');
            let fullWidth = false;
            // if class on image is only 'image' then must be full width
            if (figure != null && figure.classList.length === 1 && figure.classList[0] === 'image') {
                fullWidth = true;
            }
            this.post.content = this.post.content.replace(/<figure.+?class='.*?image.*?'.*?>.+<\/figure>/, '');
            if (fullWidth === true) {
                let thumb = document.getElementById('thumbnail');
                thumb.classList.add('u-absolute-full-width');
                let fullWidthImage = document.querySelector('#thumbnail img');
                setTimeout(() => {
                    console.log('fullWidthImage.offsetHeight', fullWidthImage.offsetHeight);
                    let wrapperHeight = fullWidthImage.offsetHeight;
                    // wrap thumb in a static div
                    let parent = thumb.parentNode;
                    let wrapper = document.createElement('div');
                    wrapper.style.position = 'static';
                    wrapper.style.height = wrapperHeight + 'px';
                    parent.replaceChild(wrapper, thumb);
                    wrapper.appendChild(thumb);
                }, 100);
            }
        }*/
    },
    destroy() {
        window.removeEventListener('resize', this.monitorResize);
    },
    computed: {
        player() {
            return this.$refs.youtube.player;
        },
    },
    methods: {
        loadPost(dyadeyId, postId, networkId) {
            this.$http.post('/api/v1/posts/get', { dyadeyId: dyadeyId, postId: postId})
                .then((response) => {
                    let post = response.data;
                    this.showPost(post);
                    this.$root.$emit('bus-network-post-loaded');
                });

        },
        showPost(post) {
            this.post = post;
            if (typeof this.post.meta_data != 'undefined' && this.post.meta_data != null) {
                let isIframe = /<iframe/.test(this.post.source);
                if (isIframe) {
                    const iframeWidthParts = /<iframe.+width="([0-9]+)"/.exec(this.post.source);
                    const iframeHeightParts = /<iframe.+height="([0-9]+)"/.exec(this.post.source);
                    if (iframeWidthParts && iframeHeightParts) {
                        let width = parseInt(iframeWidthParts[1]);
                        let height = parseInt(iframeHeightParts[1]);
                        let aspectRatio = (100 * (height / width)).toFixed(2);
                        this.post.aspectRatio = aspectRatio + '%';
                    }
                } else {
                    let metaData = JSON.parse(this.post.meta_data);
                    if (typeof metaData.thumbnail_dimensions != 'undefined') {
                        const widthParts = /width="([0-9]+)"/.exec(metaData.thumbnail_dimensions);
                        const heightParts = /height="([0-9]+)"/.exec(metaData.thumbnail_dimensions);
                        if (widthParts && heightParts) {
                            let width = parseInt(widthParts[1]);
                            let height = parseInt(heightParts[1]);
                            let aspectRatio = (100 * (height / width)).toFixed(2);
                            this.post.aspectRatio = aspectRatio + '%';
                        }
                    }
                    // if there is no video URL to show then show oembed panel
                    if (this.post.network_id === this.$simpleStore.Networks.IN &&
                        this.post.type === 'video' &&
                        this.post.uri == null) {
                        this.instagramEmbed = metaData.oembed.html
                            .replace(/display: block;/g, '');
                    }
                }
            }
            if (this.post.user_id == null && this.post.content !== this.post.post_page_title) {
                // TODO: check how UGC is affected written on Macs iOS
                // do not replace \r\n with <br> only replace \n with <br>
                this.post.content = this.post.content.replace(/\r\n/g, '');
                this.post.content = this.post.content.replace(/([^\n])\n\n/g, '$1<br><br>');
                this.post.content = this.post.content.replace(/([^\n])\n/g, '$1<br>');
            }
            if (this.post.post_page_title.indexOf('This content isn\'t available') !== -1) {
                const maxTitleLength = 50;
                if (this.post.content.length <= maxTitleLength) {
                    this.post.post_page_title = this.post.content;
                } else {
                    let titleLength = this.post.content.substring(0, maxTitleLength).lastIndexOf(' ');
                    this.post.post_page_title = this.post.content.substring(0, titleLength) + ' ...';
                }
            }
            this.$root.$emit(
                'bus-update-post-data',
                this.post.birthday_short,
                this.post.birthday_long,
                this.post.post_page_title
            );
            if (this.post.network_id === this.$simpleStore.Networks.DY && this.post.thumbnail) {
                this.setHeroContainerSize();
            }
            if (this.post.media_attachments != null) {
                this.post.media_attachments = JSON.parse(
                    this.post.media_attachments
                );
            }
        },
        playing() {
            //console.log('\o/ we are watching!!!');
        },
        setHeroContainerSize() {
            let img = new Image();
            img.onload = () => {
                if (this.post.hero_size !== 'normal') {
                    let heroImage = document.querySelector('#thumbnail img');
                    heroImage.parentElement.style.height = heroImage.clientHeight + 'px';
                }
                console.log('image loaded');
            };
            img.src = this.post.thumbnail;
        },
        monitorResize() {
            if (this.post.network_id === this.$simpleStore.Networks.DY && this.post.thumbnail) {
                clearTimeout(window.resizedFinished);
                window.resizedFinished = setTimeout(() => {
                    this.setHeroContainerSize();
                }, 250);
            }
        },
        updateSlide(ev, post) {
            // show placeholder while slides updating to avoid a broken image
            let slideId = ev.composedPath()[0].id;
            let slide = document.getElementById(slideId);
            if (slideId === 'slide-0') {
                slide.src = this.$cdn('/img/slideshow-updating.png');
            }
            // do not try to update slides while already updating
            if (this.updatingSlides === true) {
                return;
            }
            let postId = post.post_id;
            let networkId = post.network_id;
            // only check FB and Insta posts
            if (networkId !== this.$simpleStore.Networks.FB && networkId !== this.$simpleStore.Networks.IN) {
                return;
            }
            // get updated post data and update first slide
            this.updatingSlides = true;
            this.$http.post('/api/v1/posts/update', { postId: postId, networkId: networkId, cacheId: post.cache_id })
                .then((response) => {
                    if (response.data.success === true) {
                        this.updatedSlides = response.data.post_attachments;
                        let slides = networkId === this.$simpleStore.Networks.FB
                            ? this.$refs.fbSlides
                            : this.$refs.inSlides;
                        for (let i = 0; i < this.updatedSlides.length; i++) {
                            let el = slides.querySelector('#slide-' + i);
                            if (el) {
                                el.src = this.updatedSlides[i].src;
                            }
                            // preload images
                            if (!this.updatedSlides[i].type || this.updatedSlides[i].type === 'IMAGE') {
                                let img = new Image();
                                img.src = this.updatedSlides[i].src;
                            }
                        }
                        this.updatingSlides = false;
                    }
                },
                (response) => {
                    console.log('Errored:');
                    console.log(response);
                });
        },
        toggleComments() {
            this.showComments = !this.showComments;
        },
        updatePost(event, post) {
            let postId = post.post_id;
            let networkId = post.network_id;
            // only check FB and Insta posts
            if (networkId !== this.$simpleStore.Networks.FB && networkId !== this.$simpleStore.Networks.IN) {
                return;
            }
            this.$http.post('/api/v1/posts/update', { postId: postId, networkId: networkId, cacheId: post.cache_id })
                .then((response) => {
                    this.showINVideo = true;
                    // to asynchronously update the video source we need to remove existing source and add a new one
                    // otherwise it will not show on the page
                    const videoTag = this.$refs.videoInstagram;
                    const existingSource = videoTag.querySelector('source');
                    const newSource = document.createElement('source');
                    videoTag.removeChild(existingSource);
                    newSource.setAttribute('src', response.data.uri);
                    newSource.setAttribute('type', 'video/mp4');
                    videoTag.appendChild(newSource);
                },
                (response) => {
                    console.log('Errored:');
                    console.log(response);
                });
        },
        loadInstagramScript() {
            if (this.post.network_id === this.$simpleStore.Networks.IN &&
                this.post.type === 'video' &&
                this.post.uri == null &&
                typeof window.instgrm === 'undefined') {
                const script = document.createElement('script');
                script.setAttribute('src', 'https://platform.instagram.com/en_US/embeds.js');
                script.setAttribute('async', 'true');
                document.body.appendChild(script);
                script.onload = () => {
                    window.instgrm.Embeds.process();
                    setTimeout(() => {
                        const iframe = document.querySelector('iframe.instagram-media');
                        if (iframe != null) {
                            iframe.style.marginLeft = 'auto';
                            iframe.style.marginRight = 'auto';
                        }
                    }, 2500);
                };
            } else if (typeof window.instgrm != 'undefined') {
                window.instgrm.Embeds.process();
            }
        }
    },
    directives: {
        twitteremoji: {
            inserted(el) {
                if (typeof TwitterEmoji === 'object' && typeof TwitterEmoji.parse === 'function') {
                    TwitterEmoji.parse(el, { folder: 'svg', ext: '.svg' });
                }
            },
            componentUpdated(el) {
                if (typeof TwitterEmoji === 'object' && typeof TwitterEmoji.parse === 'function') {
                    TwitterEmoji.parse(el, { folder: 'svg', ext: '.svg' });
                }
            },
        },
    },
};
</script>
